import { createFileRoute } from "@tanstack/react-router";
import { ReviewsPage } from "@/features/admin/reviews/reviews-page";
import { ReviewSearchParams, reviewSearchSchema } from "@/features/admin/reviews/constants";

export const Route = createFileRoute("/admin/reviews")({
  component: RouteComponent,
  validateSearch: reviewSearchSchema,
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const search = Route.useSearch();

  const updateSearch = (updates: Partial<ReviewSearchParams>) => {
    navigate({ search: { ...search, ...updates } });
  };

  return (
    <ReviewsPage
      search={search}
      onSearchChange={updateSearch}
      onOpenDetail={(id) => {
        navigate({
          to: "/admin/queue/$id",
          params: { id },
        });
      }}
    />
  );
}
